import {ContentSlide} from "@web-libs/ui/ui-components/slider/content-slider.types";
import {useEffect, useRef, useState} from "react";
import {first} from "@web-libs/util/arrays/array.functions";

export const useContentSlider = (contentSlides: ContentSlide[], onNavClick?: (navId?: string) => void) => {

    const firstContentSlide = first(contentSlides)
    const [
        currentSlide,
        setCurrentSlide
    ] = useState<ContentSlide | undefined>(firstContentSlide);

    if(currentSlide === undefined && firstContentSlide){
        setCurrentSlide(firstContentSlide)
    }

    const [allSlides, setAllSlides] = useState<ContentSlide[]>(contentSlides)

    useEffect(() => {
        setAllSlides(contentSlides)
    }, [contentSlides])

    const navigateToSlide = (index: number) => {
        stopSlideShow();
        setCurrentSlide(allSlides[index]);
    }

    const navigateToNextSlide = () => {
        setCurrentSlide((prevSlide) => {
            const currentIndex = allSlides.indexOf(prevSlide!);
            if (currentIndex < allSlides.length - 1) {
                return allSlides[currentIndex + 1];
            } else {
                return allSlides[0];
            }
        });
    }

    const onExternalNavigationClick = () => {
        const navId = currentSlide?.navId;
        if (onNavClick) {
            onNavClick(navId);
        }
    }

    const getCurrentSlideIndex = () => {
        return allSlides.indexOf(currentSlide!);
    }

    const interval= useRef<NodeJS.Timeout | null>(null);
    const startSlideShow = (tempo:number) => {
        if(interval.current) clearInterval(interval.current);
        interval.current = setInterval(() => {
            navigateToNextSlide();
        }, tempo);
    }

    const stopSlideShow = () => {
        if(interval.current)
            clearInterval(interval.current);
    }

    return {
        currentSlide,
        navigateToSlide,
        navigateToNextSlide,
        onNavigationClick: onExternalNavigationClick,
        getCurrentSlideIndex,
        startSlideShow,
        stopSlideShow
    }
}
